import toast from 'react-hot-toast';
import { CardHeader } from "reactstrap"

export const showToaster = (status, message) => {
  toast.dismiss();
  const formattedMessage = (message || 'An error occurred').replace(/\.\s*/g, ".\n").trim();
  const title = status == 1
    ? "Success!"
    : status == 0
      ? "Failure!"
      : ""
  const msg = (
    <div style={{ whiteSpace: "pre-line", maxWidth: "300px" }}>
      <strong>{title}</strong>
      <br />
      {formattedMessage}
    </div>
  );

  if (status) {
    toast.success(msg, { duration: 6000 });
  } else {
    toast.error(msg, { duration: 6000 });
  }
};

export const copyText = async (text) => {
  if (!text) {
    return
  }
  try {
    await navigator.clipboard.writeText(text);
    showToaster(true, 'Copied to clipboard!')
  } catch (err) {
    toast.error('Failed to copy!');
  }
};

export const utcToNormalTime = (utcString) => {
  if (!utcString) return "-"; // Handle null/undefined values

  const date = new Date(utcString);
  if (isNaN(date)) return "-"; // Handle invalid dates

  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const formattedDate = `${date.getDate().toString().padStart(2, "0")}-${months[date.getMonth()]}-${date.getFullYear()}`;

  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";

  hours = hours % 12 || 12; // Convert 0 to 12-hour format

  return `${formattedDate} ${hours.toString().padStart(2, "0")}:${minutes} ${ampm}`;
};

export const formatNumber = (value, decimal) => {
  if (isNaN(value) || !value || value === 0) {
    return '0.0000';
  }

  // Handle exponential values by converting them to fixed-point notation
  if (value.toString().includes('e') || value.toString().includes('E')) {
    value = Number(value).toFixed(decimal || 4);
  }

  if (!decimal) {
    return value.toString();
  }

  const [integerPart, fractionalPart = ''] = value.toString().split('.');
  let formattedFractionalPart = fractionalPart.substring(0, decimal);

  // Append zeros to fractional part if needed
  while (formattedFractionalPart.length < decimal) {
    formattedFractionalPart += '0';
  }

  // Combine the integer and fractional parts
  const formattedPrice = `${integerPart}.${formattedFractionalPart}`;
  return formattedPrice;
};

export const calculateEndTime = (duration, durationType) => {
  const currentDate = new Date(); // Get the current date and time
  const endLowercase = durationType.toLowerCase();
  let endDate;

  if (endLowercase === "years") {
    endDate = new Date(
      currentDate.getFullYear() + duration,
      currentDate.getMonth(),
      currentDate.getDate(),
      currentDate.getHours(),
      currentDate.getMinutes(),
      currentDate.getSeconds()
    );
  } else if (endLowercase === "months") {
    endDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + duration,
      currentDate.getDate(),
      currentDate.getHours(),
      currentDate.getMinutes(),
      currentDate.getSeconds()
    );
  } else if (endLowercase === "days") {
    endDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate() + duration,
      currentDate.getHours(),
      currentDate.getMinutes(),
      currentDate.getSeconds()
    );
  } else {
    console.error("Invalid duration type. Use 'Years', 'Months', or 'Days'.");
  }

  return endDate;
};


export const preventSpace = (e) => {
  if (e.key === ' ') {
    e.preventDefault();
  }
};


export const calculateAmountAfterFee = (amount, withdrawFee, withdrawFeeType) => {
  let amountAfterFee = amount;
  if (withdrawFeeType === 0) {
    // Fixed fee
    amountAfterFee = amount - withdrawFee;
  } else if (withdrawFeeType === 1) {
    // Percentage fee
    amountAfterFee = amount - (amount * withdrawFee / 100);
  } else if (withdrawFeeType === 2) {
    // No fee
    amountAfterFee = amount;
  }

  return amountAfterFee > 0 ? amountAfterFee : 0;
};

// export const getBadgeClass = (code) => {
//   switch (code) {
//     case UserValue.VERIFYED_USER:
//       return "badge-soft-success";
//     case UserValue.NOT_VERIFYED:
//       return "badge-soft-warning";
//     case UserValue.BLOCKED_USER:
//       return "badge-soft-danger";
//     default:
//       return "badge-soft-info";
//   }
// };
// export const getStatusText = (isActive) => {
//   switch (isActive) {
//     case UserValue.NOT_VERIFYED:
//       return "InActive";
//     case UserValue.VERIFYED_USER:
//       return "Active";
//     case UserValue.BLOCKED_USER:
//       return "Blocked";
//     default:
//       return "Unknown";
//   }
// };

export const scrollToView = (id) => {
  setTimeout(() => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  }, 0)
}

export const convertDecimalMinutesToDuration = (duration) => {
  // Handle null, undefined, NaN, or invalid values
  if (!duration || isNaN(duration) || duration <= 0) {
    return "N/A";
  }

  const minutes = Math.floor(duration / 60);
  const seconds = Math.floor(duration % 60);
  return `${minutes}m ${seconds}s`;
}

export const TableHeader = ({ scanName, scanId, customStyle }) => {
  return (
    <CardHeader style={{ ...customStyle, fontSize: '2em' }}>
      {scanName}{scanId && (<span style={{ color: '#e67552' }}> - {scanId}</span>)}
    </CardHeader>
  )
}

export const handleErrors = (error) => {
  console.error(error);
  if (error.response && error.response.data)
    showToaster(0, error.response.data.message || error.response.data.error)
  else if (error.status === 304)
    showToaster(0, 'No changes detected.')
  else
    showToaster(0, 'Something Went Wrong')
}